import { useEffect, useState } from "react";

/** Calls onReveal whenever the element given to the returned callback ref scrolls into view and loading more is allowed. */
export const useLoadMoreOnReveal = ({ enabled, onReveal }) => {
  const [node, setNode] = useState(null);

  useEffect(() => {
    if (!node || !enabled) return undefined;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) onReveal();
    });
    observer.observe(node);

    return () => observer.disconnect();
  }, [node, enabled, onReveal]);

  return setNode;
};
